import { baseApi } from '@/api/rtk/baseApi';

export const toolsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getTools: builder.query({
      query: () => ({
        url: '/get-tools/',
        method: 'POST',
        body: {},
      }),
      providesTags: ['Tools'],
    }),
  }),
});

export const { useGetToolsQuery } = toolsApi;
